import { render } from "./ResponseCard.vue?vue&type=template&id=c460a2be&scoped=true"
import script from "./ResponseCard.vue?vue&type=script&lang=js"
export * from "./ResponseCard.vue?vue&type=script&lang=js"

import "./ResponseCard.vue?vue&type=style&index=0&id=c460a2be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c460a2be"],['__file',"src/components/ResponseCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c460a2be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c460a2be', __exports__)) {
    api.reload('c460a2be', __exports__)
  }
  
  module.hot.accept("./ResponseCard.vue?vue&type=template&id=c460a2be&scoped=true", () => {
    api.rerender('c460a2be', render)
  })

}


export default __exports__